var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMovil = function SvgIconMovil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.1 249"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ed2124",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4 242.5H34.6c-15.5 0-28.1-12.7-28.1-28.1V34.6c0-15.5 12.7-28.1 28.1-28.1h64.8c15.5 0 28.1 12.7 28.1 28.1v179.7c.1 15.5-12.6 28.2-28.1 28.2z",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 203.5h121.1",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 31h23.3",
    strokeWidth: 5
  }))));
};
export default SvgIconMovil;